module.exports = __webpack_public_path__ + "static/img-3d-modeling-760699f25f2675674b96364f60fd972c.jpg";